// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screener-container {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  cursor: auto;
  box-sizing: border-box;
  container-type: inline-size;
  width: 100%;
  height: 100%;
  min-width: 328px;
}

/* Only while the popup is open: it is capped at 100% of this container, so
   a short one would squash it. Unconditionally this left a blank gap. */
.screener-container-criteria-open {
  min-height: 900px;
}

.screener {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}

.screener-title {
  width: 100%;
  height: 32px;

  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: start;
  align-content: center;
}

.screener-table-pagination-wrapper {
  flex: 1;
  min-height: 600px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.screener-table-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.screener-pagination-container {
  flex-shrink: 0;
  margin-top: 24px;
}

.screener-loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  height: 100dvh;
}

.screener-loading-spinner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.screener-empty-text {
  margin-top: 20px;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: var(--text-primary);
}

.screener-advanced-criteria-backdrop {
  /* Covers the screener container only — matches the popup, which is
     centred on that container rather than on the viewport. */
  position: absolute;
  inset: 0;
  z-index: 999;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/ScreenerWidget/ScreenerWidget.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;wEACwE;AACxE;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE;6DAC2D;EAC3D,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd","sourcesContent":[".screener-container {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  cursor: auto;\n  box-sizing: border-box;\n  container-type: inline-size;\n  width: 100%;\n  height: 100%;\n  min-width: 328px;\n}\n\n/* Only while the popup is open: it is capped at 100% of this container, so\n   a short one would squash it. Unconditionally this left a blank gap. */\n.screener-container-criteria-open {\n  min-height: 900px;\n}\n\n.screener {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n.screener-title {\n  width: 100%;\n  height: 32px;\n\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: start;\n  align-content: center;\n}\n\n.screener-table-pagination-wrapper {\n  flex: 1;\n  min-height: 600px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n}\n\n.screener-table-loading-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.7);\n  z-index: 10;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.screener-pagination-container {\n  flex-shrink: 0;\n  margin-top: 24px;\n}\n\n.screener-loading-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 4px;\n  height: 100dvh;\n}\n\n.screener-loading-spinner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.screener-empty-text {\n  margin-top: 20px;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 20px;\n  line-height: 28px;\n  letter-spacing: 0px;\n  text-align: center;\n  vertical-align: middle;\n  color: var(--text-primary);\n}\n\n.screener-advanced-criteria-backdrop {\n  /* Covers the screener container only — matches the popup, which is\n     centred on that container rather than on the viewport. */\n  position: absolute;\n  inset: 0;\n  z-index: 999;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
